export function joinCopyableLogParts(...parts: Array<string | null | undefined>): string {
  return parts
    .map(part => (part ?? '').trim())
    .filter(Boolean)
    .join('\n\n');
}

export function formatOperationLogsForCopy(
  entries: Array<{
    timestamp?: string | Date;
    level?: string | null;
    serviceName?: string | null;
    loggerName?: string | null;
    message?: string | null;
    traceId?: string | null;
    exception?: string | null;
  }>,
): string {
  return entries
    .map(entry => {
      const timestamp = entry.timestamp instanceof Date
        ? entry.timestamp.toISOString()
        : (entry.timestamp ?? '');
      const header = [timestamp, entry.level, entry.serviceName]
        .map(part => (part ?? '').toString().trim())
        .filter(Boolean)
        .join(' ');
      return joinCopyableLogParts(
        header,
        entry.loggerName,
        entry.message,
        entry.traceId ? `Trace ID: ${entry.traceId}` : null,
        entry.exception,
      );
    })
    .filter(Boolean)
    .join('\n\n');
}
